import React, { useState, useEffect } from "react";
import axios from "axios";
import { Form, Input, InputNumber, Button, Select } from "antd";
// const { Option } = Select;
import HotelPhotoUpload from "../../components/HotelPhotoUpload";

import Swal from "sweetalert2";

import Loader from "../../components/Loader";
import Error from "../../components/Error";
const layout = {
  labelCol: {
    span: 4,
  },
  wrapperCol: {
    span: 16,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};
function HotelAdminAddRoomScreen() {
  const { Option } = Select;

  const [room, setRoom] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [imageUrls, setImageUrls] = useState([]);
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    console.log(values);
    setError("");
    setLoading(true);
    try {
      const data = (await axios.post("/api/hotels/addhotel", values)).data;
      Swal.fire("Congratulations", "Your Hotel Added Successfully", "success");
      form.resetFields();
    } catch (error) {
      console.log(error);
      setError(error);
      Swal.fire("Opps", "Error:" + error, "error");
    }

    setLoading(false);
  };

  const onReset = () => {
    form.resetFields();
  };

  return (<div className="row">
    {loading ? (
      <Loader></Loader>
    ) : error.length > 0 ? (
      <Error msg={error}></Error>
    ) : (
      <div className="col-md-12">
        <Form
          {...layout}
          form={form}
          name="control-hooks"
          onFinish={onFinish}
        >
          <Form.Item
            name="name"
            label="Name"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="address"
            label="Address"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="city"
            label="City"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="phoneNumber"
            label="Phone Number"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input type="number" />
          </Form.Item>
          <Form.Item
            name="maxcount"
            label="Max Room Count"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input type="number"/>
          </Form.Item>
          <Form.Item
            name="description"
            label="Description"
            rules={[
              {
                required: true,
              },
            ]}
          >
            {/* <Input /> */}
            <Input.TextArea rows={4} />
          </Form.Item>
          <Form.Item
            name="email"
            label="Email"
            rules={[
              {
                // required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="website"
            label="Website"
            rules={[
              {
                // required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="rating"
            label="Rating"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <InputNumber min={1} max={5} />
          </Form.Item>
            {imageUrls.map((imageUrl, index) => (
          <Form.Item
            key={index}
            name={`imageurl${index + 1}`}
            label={`imageurl${index + 1}`}
            rules={[
              {
                // required: true,
              },
            ]}
            initialValue={imageUrl}
          >
            <Input />
          </Form.Item>
        ))}
        <Form.Item
          name="Upload Multiple Images at Once"
          label="Upload Multiple Images at Once"
          rules={[
            {
              // required: true,
            },
            ]}>
          <HotelPhotoUpload setImageUrls={setImageUrls} />        
        </Form.Item>

          {/* Add other properties based on the hotel schema */}
          <Form.Item {...tailLayout}> 
            <Button type="primary" htmlType="submit">
              Add
            </Button>
            <Button htmlType="button" onClick={onReset}>
              Reset
            </Button>
          </Form.Item>
        </Form>
      </div>
    )}
  </div>
  );
};

export default HotelAdminAddRoomScreen;